import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, LibraryBigIcon } from 'lucide-react';
import { SectionHeading } from './ui/SectionHeading';
import { modules } from '../data/modules';
import { totalVolumes } from '../data/offer';
export function ModulesSection() {
  return <section className="bg-carbon py-16 sm:py-20" aria-labelledby="modules-title" data-id="element-142" data-mp="1dwqf8o5f0u06">
      <div className="mx-auto max-w-6xl px-4" data-id="element-143" data-mp="2bk8oe02zny4p">
        <div className="text-center" data-id="element-144" data-mp="2bixnq94ub6ht">
          <span className="inline-flex items-center gap-2 rounded-full border border-lava/40 bg-petrol px-4 py-2 text-xs font-bold uppercase tracking-[.14em] text-lava" data-id="element-145" data-mp="2bhwbw2g02fz1">
            <LibraryBigIcon className="h-4 w-4" aria-hidden="true" data-id="element-146" data-mp="21khvg2u2tr6q" /> Complete classroom coverage
          </span>
          <SectionHeading id="modules-title" className="mt-5" data-id="element-147" data-mp="1wmq00yu83mxs">
            The {totalVolumes} Comprehensive Volumes
          </SectionHeading>
        </div>

        <div className="mt-10 grid gap-6 lg:grid-cols-2" data-id="element-148" data-mp="l7jinupiuehk">
          {modules.map((module, index) => {
          const Icon = module.icon;
          return <motion.article key={module.title} initial={{
            opacity: 0,
            y: 16
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            amount: 0.1
          }} transition={{
            duration: 0.3,
            delay: index % 2 * 0.05,
            ease: [0.23, 1, 0.32, 1]
          }} className="flex flex-col overflow-hidden rounded-2xl border border-lava/20 bg-petrol shadow-lg shadow-black/30" data-id="element-149" data-mp="1nubksmdrwex5" data-mpi={index}>
                <div className="flex items-center gap-4 border-b border-lava/30 bg-carbon/40 px-6 py-5" data-id="element-150" data-mp="14x0qlg700bok">
                  <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-lava text-carbon" data-id="element-151" data-mp="q8e9b8xt99up">
                    <Icon className="h-6 w-6" aria-hidden="true" data-id="element-152" data-mp="v3bjij6ttp96" />
                  </span>
                  <div data-id="element-153" data-mp="h891wysmabgj">
                    <p className="text-xs font-bold uppercase tracking-[.14em] text-lava" data-id="element-154" data-mp="l78f16oi5ej2">Volume {module.number}</p>
                    <h3 className="mt-1 text-lg font-bold leading-tight text-snow" data-id="element-155" data-mp="2nuf3k1bt2i8f">{module.title}</h3>
                  </div>
                </div>

                <div className="flex flex-1 flex-col p-6" data-id="element-156" data-mp="2j1c81nngwypl">
                  <p className="font-semibold text-snow" data-id="element-157" data-mp="2e5dqaiwnaey5">{module.subtitle}</p>

                  <p className="mt-5 text-xs font-bold uppercase tracking-[.12em] text-lava" data-id="element-158" data-mp="295rbi5164qn8">
                    What does it solve in the classroom?
                  </p>
                  <p className="mt-2 text-sm leading-relaxed text-muted" data-id="element-159" data-mp="36qnbxe04797y">{module.context}</p>

                  <ul className="mt-5 grid flex-1 content-start gap-2" data-id="element-160" data-mp="31s3ota9sbre0">
                    {module.items.map(item => <li key={item} className="flex gap-2.5 text-sm leading-snug text-snow" data-id="element-161" data-mp="2sti8llrscoge">
                        <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-lava" aria-hidden="true" data-id="element-162" data-mp="1lfevs7zolpm3" />
                        {item}
                      </li>)}
                  </ul>

                  <p className="mt-6 rounded-xl border-l-4 border-lava bg-carbon/50 p-4 text-sm leading-relaxed text-muted" data-id="element-163" data-mp="3t1oqwrim57lj">
                    <b className="font-extrabold text-lava" data-id="element-164" data-mp="ynugafhqioa">Result: </b>
                    {module.result}
                  </p>
                </div>
              </motion.article>;
        })}
        </div>

        <div className="mt-8 flex flex-col items-center justify-between gap-4 rounded-2xl border border-lava/60 bg-petrol px-6 py-6 text-center sm:flex-row sm:text-left" data-id="element-165" data-mp="ap0c9uvx7xqq">
          <p className="text-xs font-bold uppercase tracking-[.16em] text-muted" data-id="element-166" data-mp="kktwm0fvsvj2">Main collection</p>
          <p className="font-display text-3xl font-bold text-snow sm:text-4xl" data-id="element-167" data-mp="omyp2vulfm44">
            {totalVolumes} premium volumes <span className="mx-2 text-lava" data-id="element-168" data-mp="tl06zdga9fe0">·</span> Updated for 2026
          </p>
        </div>
      </div>
    </section>;
}